// tslint:disable-next-line:no-empty-interface
import {strEnum} from "../../types";
import {ITCIUserInfo} from "./tci-user";
export const NavBarNotificationType = strEnum(["ORG_CHANGE", "ORG_CHANGE_IN_OTHER_TAB", "SIGN_OUT", "REGION_CHANGE"]);
export type NavBarNotificationType = keyof typeof NavBarNotificationType;

export interface ITCIOrgChangeNotification {
    notification: NavBarNotificationType | string;
    data?: any;
    userinfo: ITCIUserInfo;
}




